import React from 'react'
import { useEffect, useState } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom'

import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

import Cat from './Cat'
import TextBubble from './TextBubble'
import Header from './Header'
import Chat from './Chat'
import Posts from './Posts'
import Nav from './Nav'


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyA-uCmA1_terPO4VEAT0ilhXzXemSQI2Rs',
  authDomain: 'psych-cat.firebaseapp.com',
  projectId: 'psych-cat',
  storageBucket: 'psych-cat.firebasestorage.app',
  messagingSenderId: '970408063386',
  appId: '1:970408063386:web:bcae14cedf610555714a23',
  measurementId: 'G-JJHEH62NQ4'
}


// Initialize Firebase
const app = initializeApp(firebaseConfig)

// eslint-disable-next-line
const analytics = getAnalytics(app)


const greetings = [
  'Hii :3',
  'Sup\'',
  'Bruh!',
  'Hello',
  'Yooo',
  ' Hey!',
  ' 🐈 🐈',
  ' 🍣 ?',
  ' 🐟 ?',
  ' 🐠 ?',
  ' 🎣 ?',
]


const App = () => {

  const [greeting, setGreeting] = useState(true)

  useEffect(() => {
    const index = Math.floor(Math.random() * greetings.length)
    setGreeting(greetings[index])
  }, [])

  const renderPosts = () => {
    return (
      <React.Fragment>
        <Header />
        <Posts />
        <Nav />
      </React.Fragment>
    )
  }

  const renderCommunityChat = () => {
    return (
      <React.Fragment>
        <Header />
        <Chat app={app} />
        <Nav />
      </React.Fragment>
    )
  }

  const renderLandingPage = () => {
    return (
      <React.Fragment>
        <Cat />
        <TextBubble text={greeting} />
        <Header />
        <Nav />
      </React.Fragment>
    )
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={renderLandingPage()} />
        <Route path="/chat" element={renderCommunityChat()} />
        <Route path="/posts" element={renderPosts()} />
        <Route path="/merch" element={renderLandingPage()} />
      </Routes>
    </Router>
  )
}


export default App
